import { render, staticRenderFns } from "./tipsTable.vue?vue&type=template&id=4041085c"
import script from "./tipsTable.vue?vue&type=script&lang=js"
export * from "./tipsTable.vue?vue&type=script&lang=js"
import style0 from "./tipsTable.vue?vue&type=style&index=0&id=4041085c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports